import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import { useState } from "react";

import {
  breaksChangeThreshold,
  styledBrokenThreshold,
  formatPercentageChange,
} from "@/components/membership/Preview/previewUtils";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function HistogramTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function HistorgramTabs({ fieldData }) {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box className="preview-summary-tabs">
      {fieldData.length > 0 && (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="preview-form-tabs"
            >
              {fieldData.map((field, index) => (
                <Tab
                  label={field.field_name}
                  key={index}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {fieldData.map((field, index) => (
            <HistogramTabPanel value={value} index={index} key={index}>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">Last Upload</TableCell>
                      <TableCell align="right">Current Upload</TableCell>
                      <TableCell align="right">Percentage Change</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(field.histogram).map((item) => (
                      <TableRow
                        key={item}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {item}
                        </TableCell>
                        <TableCell align="right">
                          {field.histogram[item].prior}
                        </TableCell>
                        <TableCell align="right">
                          {field.histogram[item].current}
                        </TableCell>
                        <TableCell align="right">
                          {breaksChangeThreshold(
                            field.histogram[item].pct_change
                          )
                            ? styledBrokenThreshold(
                                field.histogram[item].pct_change
                              )
                            : formatPercentageChange(
                                field.histogram[item].pct_change
                              )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </HistogramTabPanel>
          ))}
        </Box>
      )}
    </Box>
  );
}

HistorgramTabs.propTypes = {
  fieldData: PropTypes.array,
};

export default HistorgramTabs;
